/**
 * @classdesc Turkish Language Pack
 * @desc This class will used to translate tokens into the Turkish language.
 * @namespace Languages.Turkish
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Turkish
 */
export const dictionary = {
	'years'   : 'Yıl',
	'months'  : 'Ay',
	'days'    : 'Gün',
	'hours'   : 'Saat',
	'minutes' : 'Dakika',
	'seconds' : 'Saniye'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Turkish
 */
export const aliases = ['tr', 'tr-tr', 'turkish'];
